import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const VideoCourseSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='69' height='61' viewBox='0 0 69 61' fill='none'>
    <path
      d='M8.72307 29.4114C4.44479 38.134 8.45215 47.6838 17.6738 50.7414L32.3439 55.6056C40.2072 58.2129 49.539 54.2969 53.1871 46.8592L58.0209 37.0041C63.8635 25.0921 58.3908 12.0505 45.7974 7.87482C33.2039 3.69917 18.2584 9.97072 12.4158 21.8827L8.72307 29.4114Z'
      fill='url(#paint0_linear_9299_6144)'
    />
    <g clipPath='url(#clip0_9299_6144)'>
      <path
        d='M48.2211 45.9619H21.3524C19.6116 45.9595 17.943 45.2666 16.7125 44.0353C15.482 42.8039 14.7903 41.1348 14.7891 39.394V24.1868C14.7903 22.446 15.482 20.7768 16.7125 19.5455C17.943 18.3142 19.6116 17.6213 21.3524 17.6188H48.2211C49.9623 17.6213 51.6315 18.314 52.8627 19.5452C54.0939 20.7764 54.7866 22.4456 54.7891 24.1868V39.394C54.7866 41.1352 54.0939 42.8044 52.8627 44.0356C51.6315 45.2668 49.9623 45.9595 48.2211 45.9619ZM21.3524 19.456C20.0989 19.4584 18.8975 19.9578 18.0116 20.8446C17.1256 21.7314 16.6275 22.9333 16.6262 24.1868V39.394C16.6275 40.6475 17.1256 41.8494 18.0116 42.7362C18.8975 43.623 20.0989 44.1223 21.3524 44.1248H48.2211C49.4754 44.1235 50.678 43.6247 51.5649 42.7378C52.4519 41.8509 52.9507 40.6483 52.9519 39.394V24.1868C52.9507 22.9325 52.4519 21.7299 51.5649 20.843C50.678 19.956 49.4754 19.4572 48.2211 19.456H21.3524Z'
        fill='#231F20'
      />
      <path
        d='M21.2744 25.5233C22.2789 25.5233 23.0932 24.709 23.0932 23.7045C23.0932 22.7 22.2789 21.8857 21.2744 21.8857C20.2699 21.8857 19.4556 22.7 19.4556 23.7045C19.4556 24.709 20.2699 25.5233 21.2744 25.5233Z'
        fill='#231F20'
      />
      <path
        d='M41.7361 52.438H27.8424C27.5988 52.438 27.3651 52.3412 27.1929 52.169C27.0206 51.9967 26.9238 51.763 26.9238 51.5194C26.9238 51.2758 27.0206 51.0421 27.1929 50.8699C27.3651 50.6976 27.5988 50.6008 27.8424 50.6008H41.7361C41.9797 50.6008 42.2134 50.6976 42.3856 50.8699C42.5579 51.0421 42.6547 51.2758 42.6547 51.5194C42.6547 51.763 42.5579 51.9967 42.3856 52.169C42.2134 52.3412 41.9797 52.438 41.7361 52.438Z'
        fill='#231F20'
      />
      <path
        d='M38.6723 30.966C38.8173 31.0493 38.9378 31.1693 39.0216 31.3141C39.1054 31.4588 39.1495 31.6231 39.1495 31.7904C39.1495 31.9576 39.1054 32.1219 39.0216 32.2667C38.9378 32.4114 38.8173 32.5315 38.6723 32.6148L35.2643 34.5852L31.8563 36.551C31.7112 36.6348 31.5465 36.6789 31.3788 36.679C31.2112 36.679 31.0465 36.6349 30.9013 36.5511C30.7561 36.4673 30.6355 36.3468 30.5516 36.2017C30.4677 36.0565 30.4234 35.8919 30.4233 35.7242V27.8565C30.4234 27.6889 30.4677 27.5242 30.5516 27.3791C30.6355 27.2339 30.7561 27.1134 30.9013 27.0296C31.0465 26.9459 31.2112 26.9018 31.3788 26.9018C31.5465 26.9018 31.7112 26.946 31.8563 27.0298L35.2643 28.9956L38.6723 30.966Z'
        fill='#231F20'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_9299_6144'
        x1='36.718'
        y1='66.9698'
        x2='71.2889'
        y2='18.7031'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C1BDB4' />
        <stop offset='0.396113' stopColor='#DED6C7' />
        <stop offset='1' stopColor='#F5F3EE' />
      </linearGradient>
      <clipPath id='clip0_9299_6144'>
        <rect width='40' height='34.8192' fill='white' transform='translate(14.7891 17.6188)' />
      </clipPath>
    </defs>
  </svg>
);

export const VideoCourseIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={VideoCourseSvg} {...props} />
);
